import { createFileRoute } from "@tanstack/react-router";

import { HStack } from "@/components/Layout";

import { usePackage } from "./-hooks/usePackage";

export const Route = createFileRoute(
  "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id, packageType } = Route.parentRoute.useLoaderData();
  const { Component } = usePackage({ packageType });

  return (
    <HStack className="px-12 py-7 justify-start items-start gap-9">
      <Component instanceId={id} />
    </HStack>
  );
}
